import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Own constants/actions/components
import { getCarouselFooterAction } from 'services/actions/carousel-footer';
import { results, resultsItems } from 'services/selectors/carousel-footer';
import BannerPromotion from 'components/banner-promotion';
import LoaderCP from 'components/loader';

const Home = () => {
  const dispatch = useDispatch();
  const data = useSelector(results);
  const itemsResults = useSelector(resultsItems);

  useEffect(() => {
    dispatch(getCarouselFooterAction());
  }, []);

  return (
    <div>
      { data.isFetching ? <LoaderCP /> : '' }
      { data.error ? '' : '' }
      { itemsResults && itemsResults.results && data.isFetching === false
        ? <BannerPromotion items={itemsResults.results} />
        : '' }
    </div>
  );
};

export default Home;
